let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ipkGz")).then(() => parcelRequire('6Sw2l'));